import { RADIUS, SOFT } from "./soft-tokens";

export type FollowUpItem = { label: string; value: string };

/*
 * There is no FollowUpChips here any more.
 *
 * Owner rule, 2026-09-08: "dont ever do suggestions." A stack of questions
 * under every answer writes the traveller's next line for them. What remains
 * is the clarify case below, which is not a suggestion — it answers a question
 * the assistant just asked.
 */

/**
 * A clarifying turn's one-tap answers. Owner pick P3 V3 on the phone: the
 * answers read as gold words in a sentence, not a chip stack.
 */
export function ClarifyLinks({
  items,
  onPress,
}: {
  items: FollowUpItem[];
  onPress: (value: string) => void;
}) {
  if (items.length === 0) return null;
  return (
    <div className="mt-1.5 flex flex-wrap text-[14.5px] leading-6" style={{ color: SOFT.body }}>
      {items.map((item, i) => (
        <span key={item.value}>
          <button
            type="button"
            onClick={() => onPress(item.value)}
            className="font-bold hover:underline"
            style={{ color: SOFT.goldInk }}
          >
            {item.label}
          </button>
          {i < items.length - 1 ? <span aria-hidden="true">{"  ·  "}</span> : null}
        </span>
      ))}
    </div>
  );
}
